import styled from 'styled-components';

import { media } from '~/utils';

export const StyledMain = styled.div`
  padding-top: 85px;
  margin-right: 96px;
  margin-bottom: 50px;
  width: 600px;
  padding-left: 20px;

  ${media.mid`
    width: calc(100% - 30px);
    padding: 60px 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

export const StyledImage = styled.div`
  width: 580px;
  height: 325px;
  position: relative;

  ${media.mid`
    width: 100%;
    max-width: 580px;

    & > img {
      object-fit: cover;
    }
  `}
`;

export const StyledTitle = styled.h2`
  margin-top: 15px;
  font-size: 32px;
  line-height: 42px;
  color: #0a59a6;

  ${media.mid`
    font-size: 28px;
    line-height: 35px;
    width: 100%;
    max-width: 500px;
  `}
`;

export const StyledBody = styled.p`
  margin-top: 15px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.8px;
  text-align: left;
  white-space: pre-wrap;

  ${media.mid`
    text-align: justify;
    width: 100%;
    max-width: 500px;
  `}
`;

export const StyledRecommendTitle = styled.h3`
  margin-top: 33px;
  font-size: 24px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0px;
  text-align: left;

  ${media.mid`
    width: 100%;
    max-width: 580px;
  `}
`;

export const StyledRecommend = styled.div`
  margin-top: 15px;
  padding: 20px;
  background-color: #d2e3f2;
  gap: 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  ${media.mid`
    width: calc(100vw - 30px);
    max-width: 500px;
  `}
`;

export const StyledRecommendRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledRecommendText = styled.p`
  margin-left: 15px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #0a59a6;
`;

export const StyledMoreTitle = styled.h3`
  margin-top: 30px;
  font-size: 16px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0px;
  text-align: left;

  ${media.mid`
    width: calc(100vw - 30px);
    max-width: 500px;
  `}
`;

export const StyledLinks = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const StyledLink = styled.div`
  padding-left: 22px;
  border: 1px solid #231815;
  display: flex;
  flex-direction: row;
  gap: 43px;
  align-items: center;
  border-radius: 21px;
  overflow: hidden;

  ${media.mid`
    padding: 0 16px;
  `}
`;

export const StyledLinkBody = styled.div`
  margin: 17px 0 22px;
`;

export const StyledLinkTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;

export const StyledLinkLogo = styled.div`
  margin-top: 14px;
  position: relative;
  height: 41px;

  & > img {
    object-fit: contain;
    object-position: left;
  }
`;

export const StyledLinkText = styled.p`
  margin-top: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.8;
  text-align: left;
`;

export const StyledLinkImage = styled.div`
  position: relative;
  height: 175px;
  width: 210px;
  min-width: 210px;

  & > img {
    object-fit: cover;
  }

  ${media.mid`
    display: none;
  `}
`;
